import { Chip, TableCell, TableRow } from '@mui/material';
import ImageCell from './cells/ImageCell';
import TitleCell from './cells/TitleCell';
import DownloadsCell from './cells/DownloadsCell';
import ActionsCell from './cells/ActionsCell';
import NotificationCell from './cells/NotificationCell';

export default function AddonsTableRow({
  row,
  onEdit,
  onDelete,
  previousNotification,
  sendingNotification,
  onSendNotification,
}) {
  return (
    <TableRow hover>
      <ImageCell imgs={row.imgs} />
      <TitleCell title={row.title} tags={row.tags} />
      <TableCell>
        <Chip size="small" label={row.isTemporary ? 'Draft' : 'Live'} color={row.isTemporary ? 'warning' : 'success'} />
      </TableCell>
      {/* <TextCell text={row.text} /> */}
      <DownloadsCell downloads={row.downloads} />
      <ActionsCell onEdit={() => onEdit(row)} onDelete={() => onDelete(row._id)} />
      <NotificationCell
        row={row}
        previous={previousNotification}
        sending={sendingNotification}
        onSend={onSendNotification}
      />
    </TableRow>
  );
}
